import React from "react";
import {
  Typography,
  TextField,
  Box,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import InfoPopover from "../../../../utils/informationButton";

const RecomposeWordResponseComponent = (props) => {
  const { t } = useTranslation();

  const word = props.state.formDatas?.recomposeWordTarget || "";
  const wordLength = word.length;
  const maxRandomLetters = Math.max(0, 18 - wordLength);
  const randomEnabled = !!props.state.formDatas?.recomposeRandomLettersEnabled;
  const randomCount =
    typeof props.state.formDatas?.recomposeRandomLettersCount === "number"
      ? props.state.formDatas.recomposeRandomLettersCount
      : 0;

  return (
    <>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <Typography variant="h6" className={props.classes.responseTitle}>
          {t("newEnigma.responses")}
        </Typography>
        <InfoPopover
          title={t("newEnigma.response_recompose_word")}
          text={t("newEnigma.response_recompose_word_info")}
          src="/images/game-response-word-recomp.jpeg"
        />
      </Box>

      <TextField
        required
        fullWidth
        id="recompose-word-target"
        label={t("newEnigma.recompose_word_target_label")}
        variant="outlined"
        size="small"
        className={props.classes.textfieldResponses}
        style={{ width: "100%" }}
        value={word}
        onChange={props.updateRecomposeWordTarget}
        inputProps={{ maxLength: 12 }}
        helperText={t("newEnigma.recompose_word_target_helper", {
          min: 3,
          max: 12,
          current: wordLength,
        })}
      />
      <Typography
        style={{
          fontSize: "12px",
          color: "#94A3B8",
          textAlign: "right",
          marginTop: "4px",
        }}
      >
        {wordLength}/12
      </Typography>

      <Box
        style={{
          marginTop: "12px",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          padding: "12px",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={randomEnabled}
              onChange={props.updateRecomposeRandomLettersEnabled}
              color="primary"
            />
          }
          label={
            <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
              {t("newEnigma.recompose_word_add_random_letters")}
            </Typography>
          }
          style={{ marginLeft: 0 }}
        />

        {randomEnabled && (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              marginTop: "8px",
            }}
          >
            <TextField
              required
              id="recompose-word-random-count"
              variant="outlined"
              size="small"
              type="number"
              value={randomCount}
              onChange={props.updateRecomposeRandomLettersCount}
              className={props.classes.textfieldValue}
              InputProps={{
                inputProps: {
                  min: 1,
                  max: maxRandomLetters,
                },
              }}
            />

            <Typography className={props.classes.helperText}>
              {t("newEnigma.recompose_word_random_letters_count_helper", {
                max: maxRandomLetters,
              })}
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

export default RecomposeWordResponseComponent;

